<template>
  <div>
 <el-dialog
   width="650px"
   :visible='visible'
   @close='closeTask'
   :close-on-click-modal='false'
   :close-on-press-escape='false'
   :show-close='false'>
   <template #title>
        <div class="importBlank_title">导入银行对账单</div>
   </template>
    <el-form :model='upload_form' label-width="120px">
        <el-form-item label="导入账户">
            <el-input size="small" v-model="upload_form.zhanghu" placeholder="请输入" disabled></el-input>
            <div>
                开户银行 <span style="font-weight:bold;">{{openBank}}</span>
            </div>
        </el-form-item>
         <el-form-item label="上传对账单">
            <el-upload
                style="margin-top:15px;"
                class="upload-demo"
                drag
                accept='.xls,.xlsx'
                action=""
                :auto-upload='false'
                :on-change='changeFile'
                :file-list='fileList'
                :limit='1'
                :on-remove='removeFile'
                :class="{'not_allowed':!upload_form.zhanghu}"
                :disabled="!upload_form.zhanghu"
            >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                    <div>点击或将文件拖拽到这里上传</div>
                    <div style="color:#999">只支持上传.xls/.xlsx，且不能超过5M</div>
                </div>
            </el-upload>
            <div class="downloadTemplate" @click="downLoadTemplate">
                <i class="el-icon-download"></i>
                <div >下载模板</div>
            </div>
        </el-form-item>
    </el-form>
   <template #footer>
        <div style="text-align:center"     v-loading='loading'>
            <el-button  @click="closeDialog" size="small" style="width:120px;">取消</el-button>
            <el-button  @click="validInfo" size="small"  style="width:120px;background:#269D7B;color:#fff">确定</el-button>
        </div>
   </template>
 </el-dialog>
  </div>
</template>

<script>
import {importBankExcel} from '@/api'
export default {
    data(){
        return {
            params:new FormData(),
            fkBankContractId:'',
            openBank:'',
            loading:false,
            fileList:[],
            upload_form:{
                zhanghu:'',
            },
            visible:false,
        }
    },
    methods:{
        closeTask(){
            this.fileList=[]
            this.upload_form.zhanghu=''

        },
        /** 下载模板 */
        downLoadTemplate(){
			let cid=sessionStorage.getItem('cid');
			let token=sessionStorage.getItem('token');
            window.location.href = this.$rootUrl+'voucherChief/download?cid='+cid+'&token='+token+"&templateName=银行对账单导入通用模板.xls";
        },
        removeFile(file,fileList){
            this.fileList = fileList
        },
        changeFile(file,fileList){
            let type = file.name.slice(file.name.lastIndexOf('.')+1)
            let isLt5M = file.size / 1024 / 1024 < 5;
            if(type!='xls'&&type!='xlsx') {
                this.$message.error('文件类型只支持xls,xlsx')
                this.fileList = []
                return
            }else {
                if(this.fileList.length>=1) {
                    this.$message.error('不允许多文件上传')
                    this.fileList = []
                    return
                }
                if(!isLt5M){
                    this.$message.error('文件不能超过5m')
                    this.fileList = []
                    return
                }
                this.fileList.push(file)
            }
        },
        hanldeOpen(id,arr){
            if(arr.length){
                arr.forEach(e=>{
                    if(e.bankCardNo==id){
                        this.upload_form.zhanghu = e.abbreviation
                        this.openBank = e.name
                    }
                })
            }
            this.fkBankContractId = id||''
            this.visible = true
        },
         closeDialog(){
            this.visible = false
            this.$emit('cancle')
        },
        validInfo(){
            if(this.upload_form.zhanghu==''){
                this.$message.warning('请输入账户')
                return
            }else if(this.fileList.length<1){
                this.$message.warning('请上传对账单')
                return
            }else {
                this.params = new FormData();
                this.params.append('fkBankContractId',this.fkBankContractId)
                this.params.append('file',this.fileList[0].raw)
                this.params.append('cid',sessionStorage.getItem('cid'));
			    this.params.append('token',sessionStorage.getItem('token'));
                this.loading = true
                const instance = this.$http.create()
                instance.post(this.$rootUrl + 'bankStatement/importBankStatementByExcel',this.params).then(res=>{
                    if(res.data.code==1){
                        this.$message.success('导入成功')
                        this.closeDialog()
                        this.$emit('importExcel')
                    }else {
                        this.$message.warning(res.data.msg)
                    }
                }).finally(()=>{
                    this.loading = false
                })
            }
        },
    },
}
</script>

<style lang='less' scoped>
.not_allowed {
    /deep/ .el-upload-dragger {
    cursor: not-allowed !important;
    }
}
  .downloadTemplate {
      width: 100px;
      height: 30px;
      align-items: center;
      background: #F6F8FA;
      border-radius: 2px;
      display: flex;
      padding: 0 10px;
      color: #269D7B;
      box-sizing: border-box;
      justify-content: space-evenly;
      cursor: pointer;
  }
 .importBlank_title {
    font-size: 24px;
    margin-top: 10px;
    text-align: center;
    font-weight: bold;
    color: #333;
 }
 /deep/ .el-upload-dragger {
    background: #FBFBFB;
    width: 490px !important;
    height: 200px !important;
 }
 /deep/ .el-icon-upload {
    color: #108EE9 !important;
 }
</style>



// WEBPACK FOOTER //
// src/components/dialog/importBlankBill.vue